<template>
<vs-collapse accordion class="routine-templates-categories" >


     <vs-collapse-item class="mx-1" v-for="templateCategory in templateCategories" :key="templateCategory.name">
        <div slot="header">
          <div class="flex items-center">
            <div class="w-1/5 p-4"><img :src="templateCategory.img"/></div>
            <div class="w-4/5 text-dark">
              <div class="font-bold text-lg">{{templateCategory.title}}</div>
              <div>{{templateCategory.description}}</div>
            </div>
          </div>

      </div>
        <div v-for="routine in routinesInCategory(templateCategory.name)" :key="routine.name">
          <div @click="$emit('inpiredBy', routine)" class="mt-2 font-medium" :class="actionElementCss">
             {{routine.title}}
          </div>

        </div>
      </vs-collapse-item>


  </vs-collapse>

</template>

<script>

import RoutineTemplates from '@/models/RoutineTemplates'
import _ from 'lodash'
export default {
  components: {
  },

  data () {
    return {
      routineTemplates: [],
      templateCategories: [],
    }
  },
  mounted () {
    this.routineTemplates = RoutineTemplates.routines
    this.templateCategories = RoutineTemplates.templateCategories
  },
  methods: {
    routinesInCategory (templateCategoryName) {
      return _.filter(this.routineTemplates, (template) => _.includes(template.templateCategories, templateCategoryName))
    }
  }
}

</script>


<style>
.routine-templates-categories .vs-collapse-item--header {
  font-size: 1rem;
  padding: 0rem;
}

.routine-templates-categories .con-content--item {
  padding: 0 1rem 1rem  1rem !important;
}

</style>
